module.exports = __webpack_public_path__ + "static/img/Bachelor_010577.195711f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Bachelor_010577.jpg
// module id = 192
// module chunks = 0